import "./native-app-promo-card.scss";

import { useState } from "react";

import useDesktopChecker from "hooks/useDesktopChecker";

import { NATIVE_APP_PROMO_AD_NAME } from "utilities/Constant";

import NativeAppPromoModal, {
  NativeAppPromoContent,
  useNativeAppPromoState,
} from "components/v2/native-app-promo-modal/NativeAppPromoModal";

interface NativeAppPromoCardProps {
  readonly isModalOpenByDefault?: boolean;
}

export default function NativeAppPromoCard({ isModalOpenByDefault = false }: NativeAppPromoCardProps) {
  const isDesktop = useDesktopChecker();
  const [isModalOpen, setIsModalOpen] = useState(isModalOpenByDefault);
  const { isQrOk, onQrError, shouldShowBadges, onBadgeError } = useNativeAppPromoState();

  return (
    <>
      {isModalOpen ? (
        <NativeAppPromoModal
          onClose={() => setIsModalOpen(false)}
          showQr={isQrOk}
          onQrError={onQrError}
          onBadgeError={onBadgeError}
          showAppStoreBadge={shouldShowBadges.appStore}
          showGooglePlayBadge={shouldShowBadges.googlePlay}
        />
      ) : (
        <>
          {isDesktop && (
            <h6 className="heading-medium lo-card__label">{NATIVE_APP_PROMO_AD_NAME}</h6>
          )}
          <div className="native-app-promo-card">
            <NativeAppPromoContent
              variant={isDesktop ? "cardDesktop" : "cardMobile"}
              showQr={isQrOk}
              onQrError={onQrError}
              showAppStoreBadge={shouldShowBadges.appStore}
              showGooglePlayBadge={shouldShowBadges.googlePlay}
              onBadgeError={onBadgeError}
              onPrimaryCtaClick={() => setIsModalOpen(true)}
            />
          </div>
        </>
      )}
    </>
  );
}
